import styled from 'styled-components';
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";
import { CssRule } from "../../../../../../themes/architecture/css-helpers/css-rule";

const DefaultBox = styled.div`
  display: inline-block;
  margin: 0 auto;
`;

const PCBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
 ${CssRule.For.mobile.landscape.build()} &, ${CssRule.For.ipad.build()} & {
    width:100%;
  }
`;

export const LiveCasinoNavbarScrollDefaultBox = styledByDevice(PCBox, MobileBox);